<template>
    <div class="input_container">
        <van-field v-model="localValue" right-icon="user-circle-o"
            :type="isShow && props.isPassword ? 'password' : props.fieldType" :maxlength="props.isPassword ? 20 : 'none'"
            :placeholder="props.labelText">
            <template #right-icon>
                <div v-if="props.isPassword">
                    <img v-if="isShow" src="@/assets/loginRegister/showEye.png" alt="" width="18px"
                        class="iconImage" @click="handleShowPassword" />
                    <img v-else src="@/assets/loginRegister/hideEye.png" alt="" width="18px" class="iconImage"
                        @click="handleShowPassword" />
                </div>
            </template>
        </van-field>
    </div>
</template>

<script setup lang="ts">
import { defineProps, ref, watch, defineEmits } from 'vue'
import type { FieldType } from 'vant'

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    fieldType: {
        type: String as () => FieldType,
        default: () => 'text'
    },
    isPassword: {
        type: Boolean,
        default: () => false
    },
    labelText: {
        type: String,
        default: () => ''
    },
})

const isShow = ref(true)
const emit = defineEmits(['update:modelValue', 'valueChanged'])

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
    localValue.value = newVal
})

watch(localValue, (val) => {
    emit('update:modelValue', val)
    emit('valueChanged', val)
})
const handleShowPassword = () => {
    isShow.value = !isShow.value
}


</script>
<style scoped>
.input_container>>>.van-field {
    border-radius: 30px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.04);
    color: #ffffffd9;
    padding: 12px 20px !important;
    margin: 20px 10px 10px;
}

.input_container>>>.van-field__control {
    color: rgba(255, 255, 255, 0.85) !important;
    font-size: 13px;
}

.input_container>>>.van-field__control::placeholder {
    color: #ffffff40 !important;
    font-family: monospace;
}

.input_container>>>.van-field__right-icon {
    color: #ffffff40 !important;
}

.iconImage {
    opacity: 0.45;
}

.leftContainer {
    display: flex;
    flex-direction: row;
}

.currencyText {
    color: #ffffffa6;
    font-family: monospace;
    padding: 0 5px;
    margin: 0;
}
</style>